<template>
  <header>
    <nav
      id="navbar"
      :class="{ 'navbar-active': isNavbarActive }"
      class="fixed inset-x-0 z-20 w-full border-b border-gray-200 bg-white/80 backdrop-blur shadow-sm"
    >
      <div class="mx-auto px-4 py-4 lg:py-0 xl:max-w-7xl xl:px-0">
        <div class="relative flex flex-wrap items-center justify-between lg:gap-0 lg:py-4">
          <div class="flex">
            <div class="relative z-20 flex w-full justify-between md:px-0 lg:w-max">
              <router-link @click="closeMenu" to="/" class="flex items-center space-x-2">
                <Image src="/logo.png" alt="favicon" class="!h-8 !w-auto" />
              </router-link>
            </div>
            <div
              id="layer"
              aria-hidden="true"
              class="fixed inset-0 z-10 h-screen w-screen origin-bottom scale-y-0 bg-white/70 backdrop-blur-2xl transition duration-500 lg:hidden"
            ></div>
            <div
              class="invisible absolute top-full z-20 w-full ml-5 origin-top-right translate-y-1 scale-90 flex-col flex-wrap justify-end gap-6 rounded-3xl border border-gray-100 bg-white p-8 opacity-0 shadow-2xl shadow-gray-600/10 transition-all duration-300 lg:visible lg:relative lg:flex lg:w-auto lg:translate-y-0 lg:scale-100 lg:flex-row lg:items-center lg:gap-0 lg:border-none lg:bg-transparent lg:p-0 lg:opacity-100 lg:shadow-none lg:peer-checked:translate-y-0"
            >
              <div class="text-black lg:pr-4">
                <div class="space-y-6 tracking-wide lg:flex lg:space-y-0 lg:text-sm">
                  <div
                    :class="{ 'bg-gray-400/20': isRouteActive('/products') }"
                    class="block transition text-md font-medium p-2.5 rounded-md group/products hover:cursor-pointer hover:bg-gray-400/20 md:px-4"
                  >
                    <span>Productos</span>

                    <products-dropdown />
                  </div>

                  <div
                    :class="{ 'bg-gray-400/20': isRouteActive('/solutions') }"
                    class="block transition text-md font-medium p-2.5 rounded-md group/solutions hover:cursor-pointer hover:bg-gray-400/20 md:px-4"
                  >
                    <span>Soluciones</span>

                    <solutions-dropdown />
                  </div>

                  <router-link
                    active-class="bg-gray-400/20"
                    v-for="menu in navbarMenus"
                    :to="menu.route"
                    class="block transition text-md font-medium p-2.5 rounded-md hover:bg-gray-400/20 md:px-4"
                  >
                    <span>{{ menu.name }}</span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="hidden lg:flex items-center mr-2">
              <a
                :href="appLoginUrl"
                class="flex items-center space-x-2 text-sm font-medium p-2.5 rounded-lg bg-gray-400/20 hover:bg-gray-600/20 text-gray-800 md:px-4"
              >
                <span>Ingresar</span>
              </a>
            </div>
            <button
              @click="toggleMenu"
              id="hamburger"
              class="-mr-1 p-2 rounded-lg bg-gray-400/20 lg:hidden"
            >
              <div
                aria-hidden="true"
                class="m-auto h-0.5 w-5 rounded bg-sky-900 transition duration-300"
              ></div>
              <div
                aria-hidden="true"
                class="m-auto mt-2 h-0.5 w-5 rounded bg-sky-900 transition duration-300"
              ></div>
            </button>
            <div class="hidden lg:flex">
              <a
                :href="appSignupUrl"
                class="bg-black flex w-full items-center p-2.5 rounded-lg hover:bg-black/80 md:px-4"
              >
                <span class="text-sm font-semibold text-white"> Crea tu cuenta </span>
              </a>
            </div>
            <div
              v-show="isMenuVisible"
              class="mt-2 sm:mt-0 lg:hidden absolute top-full inset-x-[-1rem] bg-white shadow-md z-10 rounded-bl-lg rounded-br-lg"
            >
              <div class="py-2">
                <div
                  @click="toggleProductsDropdown"
                  class="flex justify-between items-center transition text-md font-medium py-4 px-4 rounded-md border-b border-gray-200"
                >
                  <span
                    :class="
                      isProductsDropdownVisible
                        ? 'text-md font-medium leading-6 text-gray-500'
                        : 'text-md font-medium'
                    "
                  >
                    Productos
                  </span>
                  <svg
                    :class="isProductsDropdownVisible ? 'transform rotate-180' : ''"
                    class="transition-transform h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                <div v-show="isProductsDropdownVisible">
                  <products-dropdown @closeDropdown="closeMenu" />
                </div>
                <div
                  @click="toggleSolutionsDropdown"
                  class="flex justify-between items-center transition text-md font-medium py-4 px-4 rounded-md border-b border-gray-200"
                >
                  <span
                    :class="
                      isSolutionsDropdownVisible
                        ? 'text-md font-medium leading-6 text-gray-500'
                        : 'text-md font-medium'
                    "
                  >
                    Soluciones
                  </span>
                  <svg
                    :class="isSolutionsDropdownVisible ? 'transform rotate-180' : ''"
                    class="transition-transform h-4 w-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </div>
                <div v-show="isSolutionsDropdownVisible">
                  <solutions-dropdown @closeDropdown="closeMenu" />
                </div>

                <router-link
                  v-for="menu in navbarMenus"
                  :to="menu.route"
                  active-class="bg-gray-400/20"
                  class="block transition text-md font-medium py-4 px-4 rounded-md hover:bg-gray-400/20 md:px-4 border-b border-gray-200"
                  @click="closeMenu"
                >
                  <span>{{ menu.name }}</span>
                </router-link>
                <div class="flex justify-center p-3 gap-x-4">
                  <a
                    :href="appLoginUrl"
                    class="flex flex-1 items-center justify-center space-x-2 text-sm font-medium py-2.5 px-4 rounded-lg bg-gray-400/20 hover:bg-gray-600/20 text-gray-800 transition-all duration-300"
                  >
                    <span>Ingresar</span>
                  </a>

                  <a
                    :href="appSignupUrl"
                    class="flex flex-1 items-center justify-center py-2.5 px-4 rounded-lg bg-black hover:bg-black/80 text-sm font-semibold text-white transition-all duration-300"
                  >
                    <span class="text-sm font-semibold text-white"> Crea tu cuenta </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script setup lang="ts">
import { Image } from '@unpic/vue';
import { useRoute } from 'vue-router';
import { ref, computed, onMounted, onUnmounted, watch, inject } from 'vue';
import ProductsDropdown from './Dropdowns/Products.vue';
import SolutionsDropdown from './Dropdowns/Solutions.vue';

const isNavbarActive = ref(false);
const isMenuVisible = ref(false);
const isProductsDropdownVisible = ref(false);
const isSolutionsDropdownVisible = ref(false);

const route = useRoute();
const appLoginUrl: string = inject('appLoginUrl');
const appSignupUrl: string = inject('appSignupUrl');

const toggleMenu = () => {
  isMenuVisible.value = !isMenuVisible.value;
  isSolutionsDropdownVisible.value = false;
  isProductsDropdownVisible.value = false;
};

const toggleProductsDropdown = () => {
  isProductsDropdownVisible.value = !isProductsDropdownVisible.value;
  if (isSolutionsDropdownVisible.value) {
    isSolutionsDropdownVisible.value = false;
  }
};

const toggleSolutionsDropdown = () => {
  isSolutionsDropdownVisible.value = !isSolutionsDropdownVisible.value;
  if (isProductsDropdownVisible.value) {
    isProductsDropdownVisible.value = false;
  }
};

function closeMenu() {
  isMenuVisible.value = false;
  isProductsDropdownVisible.value = false;
  isSolutionsDropdownVisible.value = false;
}

const navbarMenus = ref([
  { name: 'Precios', route: '/pricing' },
  { name: 'Sobre Nosotros', route: '/about-us' },
  { name: 'Contáctanos', route: '/contact-us' }
]);

const handleClickOutside = (event) => {
  const menu = document.getElementById('navbar');
  const hamburger = document.getElementById('hamburger');
  if (
    menu &&
    !menu.contains(event.target) &&
    !hamburger.contains(event.target) &&
    isMenuVisible.value
  ) {
    closeMenu();
  }
};

watch(isMenuVisible, (newValue) => {
  if (newValue) {
    window.addEventListener('click', handleClickOutside);
  } else {
    window.removeEventListener('click', handleClickOutside);
  }
});

const isRouteActive = computed(() => {
  return (routePath: string) => route.path?.toString().includes(routePath);
});

const toggleNavbar = () => {
  isNavbarActive.value = !isNavbarActive.value;
};

onMounted(() => {
  const hamburger = document.getElementById('hamburger');
  hamburger.addEventListener('click', toggleNavbar);
});

onUnmounted(() => {
  window.removeEventListener('click', handleClickOutside);
});
</script>
